import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import InstagramBox from "@components/InstagramBox";
import ArtistCarousel from "@components/ArtistCarousel";
import Figure from "@components/Figure";
import axios from 'fetch/axios';
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";
import { useTranslation } from "@hooks/useTranslation";

const Component = () => {
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loadingBanner, setLoadingBanner] = useState(true);
  const [loadingCategories, setLoadingCategories] = useState(true);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const { lang } = useContext(LanguageCurrencyContext);
  const {translate}  = useTranslation();
  const user = JSON.parse(localStorage.getItem('user_arteonu')) || null;

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get('/banners/home?lang='+lang);
        setBanner(response.data[0]);
      } catch (error) {
        console.error('Error fetching banner', error);
      } finally {
        setLoadingBanner(false);
      }
    };
    fetchBanner();
  }, [lang]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('/categories/home?lang='+lang);
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories', error);
      } finally {
        setLoadingCategories(false);
      }
    };
    fetchCategories();
  }, [lang]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('/products/home');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products', error);
      } finally {
        setLoadingProducts(false);
      }
    };
    fetchProducts();
  }, []);

  const RowWithButton = (text, image, link,index) => {
    return (
      <div 
        key={index}
        style={{ backgroundImage: `url(${image})` }}>
        <div className="MainButton">
          <div className="ButtonLight2" style={{ cursor:"pointer" }} onClick={() => navigate(link)}>
            {text}
            <i className="icon-ArrowRight" ></i>
          </div>
        </div>
      </div>
    );
  };

  const LoadingCard = ({ cantidad = 4 }) => {
    const generateLoaderDiv = (index) => (
      <div key={index} className="col-md-3">
        <div className="wrapper">
          <div className="card-loader card-loader--tabs"></div>
        </div>
      </div>
    );
  
    return Array(cantidad).fill(0).map((_, index) => generateLoaderDiv(index));
  };
  
  const getMimeType = (url) => {
    if (!url) return undefined;
    const ext = url.split('.').pop().toLowerCase().split('?')[0];
    if (ext === 'mp4') return 'video/mp4';
    if (ext === 'mov') return 'video/quicktime';
    if (ext === 'webm') return 'video/webm';
    return undefined;
  };

  return (
    
    <section className="pt-tophead">
      
      {/* Banner */}
      {/* <article className="MainImageBox" style={{ backgroundImage: `url(${banner ? banner.desktop_image : ''})` }}> */}
      <article className="MainImageBox" >
        <div className="heroImage">
          
          <picture>
           {(banner && !banner.mobile_is_video) && <source media="(max-width: 768px)" srcSet={banner ? banner.mobile_image : ''} />}
            {(banner && !banner.desktop_is_video) && <img src={banner ? banner.desktop_image : ''} alt="Banner" />}
          </picture>

          {/* CONTENEDOR PARA VIDEO */}
          {banner && (banner.desktop_is_video || banner.mobile_is_video) && 
            <div className="video-container">
              <video className="heroVideo desktop-video" autoPlay muted loop playsInline>
                {(banner && banner.desktop_is_video) && (
                  <source
                    src={banner.desktop_image}
                    type={getMimeType(banner.desktop_image)}
                  />
                )}
                Tu navegador no soporta el video.
              </video>

              <video className="heroVideo mobile-video" autoPlay muted loop playsInline>
                {(banner && banner.mobile_is_video) && (
                  <source
                    src={banner.mobile_image}
                    type={getMimeType(banner.mobile_image)}
                  />
                )}
                Tu navegador no soporta el video.
              </video>
            </div>
          }

        </div>
        {loadingBanner ? (
          <div className="MainBox">
            <LoadingCard cantidad={1} />
          </div>
        ) : banner && banner.button && (
          <div className="MainButton">
            <div className="ButtonLight2">
            <a href={banner.link} className="link">
              {banner.button}
              <i className="icon-ArrowRight"></i>
            </a>

            </div>
          </div>
        )}
      </article>

      {/* Categorias */}
      <article className="MainBox">
        <div>
          <div className="MainContentItems MCtemsButtons">
            {loadingCategories ? LoadingCard(4) : categories.map((category,index) => (
              RowWithButton(category.name, category.desktop_image, `/category/${category.uri}`,index)
              
            ))}
          </div>
        </div>
      </article>

      {/* Artistas */}
      <article className="MainBox">
        <div>
          <ArtistCarousel />
        </div>
      </article>

      {/* Contacto */}
      <article className="Sticky">
        <div
          className="ButtonContent ButtonDark"
          onClick={() => navigate("/contacto")}
        >
          {translate('home.contact')}
        </div>
      </article>

      {/* Publicaciones Instagram */}
      <article className="MainBox">
        <div>
          <div className="WeCreateToBeYourself"></div>
          <InstagramBox />
        </div>
      </article>

      {/* Imagenes Figure */}
      <article id="NewArrivals" className="MainBox">
        <div>
          <div className="NewArrivals"></div>
          <div className="MainContentItems">
          {loadingProducts 
            ? <LoadingCard loading={true} />
            : products
                .filter(Boolean)
                .map((product, index) => (
                  <Figure key={index} image={product.desktop_image} uri={product.uri} />
                ))
          }

          </div>
        </div>
      </article>
      
      <article className="AboutBox">
        <div className="AboutUsBox">
          <div className="AboutUs"></div>
          <div className="AboutUsText">{translate('home.abouttext')}</div>
          <p>
           {translate('home.about')}
          </p>
          <div
            className="ButtonContent ButtonLightMini"
            onClick={() => navigate("/about")}
          >
            {translate('home.about_button')}
            <i className="icon-ArrowRight"></i>
          </div>
        </div>
        <div className="ArtFansBox">
          <div className="ArtFans"></div>
          <div className="StrokeDash"></div>
          <div >
            <br />
            <p>
              <b>{translate('home.li5')}</b> <br />
              <b>{translate('home.li6')} </b> 
               {translate('home.li7')}
              <b> {translate('home.li8')}</b>
               {translate('home.li9')}
            </p>
          </div>
          <br />
          <div className="ButtonContent ButtonLightMini"  onClick={() => user ? navigate("/mi-perfil/mis-beneficios"):navigate("/login")} >
            {user ? translate('benefits.redward') : translate('home.register')}
            <i className="icon-ArrowRight"></i>
          </div>
        </div>
      </article>
 
    </section>
  );
};

export default Component;
